/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Keep_EditingInputs */

const en_landing_studio_keep_editing = /** @type {(inputs: Landing_Studio_Keep_EditingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep editing this`)
};

const zh_landing_studio_keep_editing = /** @type {(inputs: Landing_Studio_Keep_EditingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续编辑这张`)
};

/**
* | output |
* | --- |
* | "Keep editing this" |
*
* @param {Landing_Studio_Keep_EditingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_keep_editing = /** @type {((inputs?: Landing_Studio_Keep_EditingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Keep_EditingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_keep_editing(inputs)
	return zh_landing_studio_keep_editing(inputs)
});
export { landing_studio_keep_editing as "landing.studio.keep_editing" }